import React, { useState, useEffect } from 'react';
import './App.css';
import './index.css';
import Authentication from './Auth.js';

export default function App() {
  const currentProject= "RHODO-001"; // Set your current project here
    return (
    <Authentication project={currentProject} />   
  )

  

 
}
